const ERRORS = {
    'unknown': 'Ошибка сервера',
    '1':       'Внутренняя ошибка базы данных',
    '2':       'Получена неизвестная команда от RESTful сервиса',
    '3':       'Неверный формат данных получен от RESTful сервиса',
    '4':       'Введены некорректные данные',
    '5':       'Нельзя осуществить вход в систему (неверный логин, пароль, отсутствует такой пользователь)',
    '6':       'Сессия не существует или истекла',
    '7':       'Доступ запрещен (нет прав, нет подходящей лицензии)',
    '8':       'Некорректный сервер назначения',
    '9':       'Отсутствует или не найден сервер обновления',
    '10':      'Отсутствует ключ сессии',
    '11':      'Отстутствует регистрация на support сервере',
    '12':      'Нет регистрации на support сервере - логин занят',
    '13':      'Переданные данные были потеряны',
    '14':      'Пользователь уже зарегистрирован в HR сети',
    '15':      'Слишком большое количество пользователей в HR сети',
    '16':      'Сотрудник не зарегистрирован в HR сети',
    '17':      'Неверный ключ аутентификации',
    '18':      'Данные не загружены',
    '19':      'Неизвестный или просроченный ключ аутентификации',
    '20':      'Данный проект тестирования завершен',
    '21':      'Логин уже зарегистрирован',
    '22':      'Неверный пользовательский логин',
    '255':     'Доступ временно заблокирован. Для разблокировки введите верный логин, пароль и символы с картинки'
};

const EN_ERRORS = {
    'unknown': 'Server error',
    '1': 'Internal database error',
    '2': 'Received an unknown command from the RESTful service',
    '3': 'Incorrect data format received from the RESTful service',
    '4': 'Incorrect data entered',
    '5': 'Unable to log in (incorrect login, password, no such user)',
    '6': 'Session does not exist or has expired',
    '7': 'Access denied (no rights, no suitable license)',
    '8': 'Incorrect destination server',
    '9': 'Update server missing or not found',
    '10': 'Missing session key',
    '11': 'No registration on support server',
    '12': 'No registration on the support server - login is busy',
    '13': 'Transmitted data was lost',
    '14': 'User is already registered in the HR network',
    '15': 'Too many users in the HR network',
    '16': 'Employee is not registered in the HR network',
    '17': 'Invalid authentication key',
    '18': 'Data not loaded',
    '19': 'Unknown or expired authentication key',
    '20': 'This testing project has been completed',
    '21': 'Login is already registered',
    '22': 'Invalid user login',
    '255': 'Access is temporarily blocked. To unlock, enter the correct login, password and characters from the image'
};

export const getRuErrorsTrnaslations = () => {
    let translations = {};

    for (let key in ERRORS) {
        translations[ERRORS[key]] = ERRORS[key];
    }

    return translations;
}

export const getEnErrorsTrnaslations = () => {
    let translations = {};

    for (let key in ERRORS) {
        translations[ERRORS[key]] = EN_ERRORS[key];
    }

    return translations;
}

export default ERRORS;
